import * as actionCreators from '@atlassian/jira-common-services/src/callback-registry/index.tsx';
import type { Actions } from './types.tsx';

const actions: Actions = {
	collapseStartAdd:
		(cb) =>
		({ dispatch }) =>
			dispatch(actionCreators.add('collapseStart', cb)),
	collapseStartRemove:
		(cb) =>
		({ dispatch }) =>
			dispatch(actionCreators.remove('collapseStart', cb)),
	collapseStartClear:
		() =>
		({ dispatch }) =>
			dispatch(actionCreators.clear('collapseStart')),
	collapseStartRun:
		() =>
		({ dispatch }) =>
			dispatch(actionCreators.run('collapseStart')),

	collapseEndAdd:
		(cb) =>
		({ dispatch }) =>
			dispatch(actionCreators.add('collapseEnd', cb)),
	collapseEndRemove:
		(cb) =>
		({ dispatch }) =>
			dispatch(actionCreators.remove('collapseEnd', cb)),
	collapseEndClear:
		() =>
		({ dispatch }) =>
			dispatch(actionCreators.clear('collapseEnd')),
	// @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
	collapseEndRun:
		// @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.


			(cb) =>
			// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
			({ dispatch }) =>
				dispatch(actionCreators.run('collapseEnd', cb)),

	expandStartAdd:
		(cb) =>
		({ dispatch }) =>
			dispatch(actionCreators.add('expandStart', cb)),
	expandStartRemove:
		(cb) =>
		({ dispatch }) =>
			dispatch(actionCreators.remove('expandStart', cb)),
	expandStartClear:
		() =>
		({ dispatch }) =>
			dispatch(actionCreators.clear('expandStart')),
	// @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
	expandStartRun:
		// @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.


			(cb) =>
			// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
			({ dispatch }) =>
				dispatch(actionCreators.run('expandStart', cb)),

	expandEndAdd:
		(cb) =>
		({ dispatch }) =>
			dispatch(actionCreators.add('expandEnd', cb)),
	expandEndRemove:
		(cb) =>
		({ dispatch }) =>
			dispatch(actionCreators.remove('expandEnd', cb)),
	expandEndClear:
		() =>
		({ dispatch }) =>
			dispatch(actionCreators.clear('expandEnd')),
	// @ts-expect-error - TS2322 - Type '(cb: any) => ({ dispatch }: { dispatch: any; }) => any' is not assignable to type 'ActionRun'.
	expandEndRun:
		// @ts-expect-error - TS7006 - Parameter 'cb' implicitly has an 'any' type.


			(cb) =>
			// @ts-expect-error - TS7031 - Binding element 'dispatch' implicitly has an 'any' type.
			({ dispatch }) =>
				dispatch(actionCreators.run('expandEnd', cb)),

	clearAll:
		() =>
		({ dispatch }) => {
			dispatch(actions.collapseStartClear());
			dispatch(actions.collapseEndClear());
			dispatch(actions.expandStartClear());
			dispatch(actions.expandEndClear());
		},
};

export default actions;
